import { ADD_USER, REMOVE_USER } from "./actions";

export const addUser = (payload) => {
  // console.log(payload);
  return {
    type: ADD_USER,
    payload: payload,
  };
};

export const removeUser = () => {
  return {
    type: REMOVE_USER,
  };
};
